// Booleovský výraz pro filtr GH_ID: LIKE vzory (stejná syntaxe jako likeMatch — %, _, prefix)
// kombinované operátory AND/OR/NOT a závorkami, např.:
//   (O1% OR O2%) AND NOT P7% AND %01
// Prostý text bez operátorů/závorek se chová identicky jako dřív (jeden LIKE vzor).
import { likeMatch } from './likeMatch'

const TOKEN_RE = /\(|\)|[^\s()]+/g

function tokenize(input) {
  return input.match(TOKEN_RE) ?? []
}

// Rekurzivní sestupný parser: expr := term (OR term)*, term := factor (AND factor)*,
// factor := NOT factor | '(' expr ')' | PATTERN
function parseExpr(tokens, pos) {
  let [node, next] = parseTerm(tokens, pos)
  while (tokens[next]?.toUpperCase() === 'OR') {
    const [right, after] = parseTerm(tokens, next + 1)
    node = { type: 'or', left: node, right }
    next = after
  }
  return [node, next]
}

function parseTerm(tokens, pos) {
  let [node, next] = parseFactor(tokens, pos)
  while (tokens[next]?.toUpperCase() === 'AND') {
    const [right, after] = parseFactor(tokens, next + 1)
    node = { type: 'and', left: node, right }
    next = after
  }
  return [node, next]
}

function parseFactor(tokens, pos) {
  const tok = tokens[pos]
  if (tok === undefined) throw new Error('Neočekávaný konec výrazu')
  if (tok.toUpperCase() === 'NOT') {
    const [inner, next] = parseFactor(tokens, pos + 1)
    return [{ type: 'not', inner }, next]
  }
  if (tok === '(') {
    const [inner, next] = parseExpr(tokens, pos + 1)
    if (tokens[next] !== ')') throw new Error('Chybí uzavírací závorka')
    return [inner, next + 1]
  }
  if (tok === ')') throw new Error('Neočekávaná uzavírací závorka')
  if (tok.toUpperCase() === 'AND' || tok.toUpperCase() === 'OR') throw new Error(`Neočekávaný operátor "${tok}"`)
  return [{ type: 'pattern', value: tok }, pos + 1]
}

// Naparsuje výraz. Vrací { ast } při úspěchu, nebo { error } při chybné syntaxi.
export function parseGhIdExpr(input) {
  const trimmed = input?.trim()
  if (!trimmed) return { ast: null }
  const tokens = tokenize(trimmed)
  try {
    const [ast, next] = parseExpr(tokens, 0)
    if (next !== tokens.length) throw new Error(`Neočekávaný text za výrazem: "${tokens.slice(next).join(' ')}"`)
    return { ast }
  } catch (err) {
    return { error: err.message }
  }
}

export function evalGhIdExpr(ghId, ast) {
  if (!ast) return true
  switch (ast.type) {
    case 'pattern': return likeMatch(ghId, ast.value)
    case 'not': return !evalGhIdExpr(ghId, ast.inner)
    case 'and': return evalGhIdExpr(ghId, ast.left) && evalGhIdExpr(ghId, ast.right)
    case 'or': return evalGhIdExpr(ghId, ast.left) || evalGhIdExpr(ghId, ast.right)
    default: return true
  }
}
